import SponsorLogoSection from '@/components/common/SponsorLogoSection/SponsorLogoSection';

import * as S from './style.ts';

const MembershipSpecial = () => (
	<S.Container>
		<SponsorLogoSection title="2026년 (사)대한화장품학회 특별회원사" />
	</S.Container>
);

export default MembershipSpecial;
